import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

/** Screen 185: Authorize job cards requested for repeat invoicing. */
export const screen_185_jobcard_invoice_auth_authorize: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Job card invoice authorization – approve",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "jobcard_no",
            Name: "jobcard_invoice_auth_authorize_summary",
            apiname: "jobcard_invoice_auth_authorize_summary",
            BindValue: "grid_jobcard_invoice_auth_authorize",
            SummeryActions: [
              {
                Action: {
                  Module: "jobcard_invoice_auth",
                },
                ActionType: "authorize",
                Label: "Approve",
                tooltip: "Approve",
                requireApprovalReason: true,
                approvalReasonLabel: "Reason for job card approval",
                confirmMessage:
                  "Enter the reason for approval, then confirm to approve this job card.",
                visibleForStatus: ["requested"],
              },
            ],
            Form: {
              Name: "jobcard_invoice_auth_authorize_summary",
              TableName: "service_job_card",
              DisplayName: "Approve job card for invoicing",
              View: "view_jobcard_invoice_authorization",
              Filter:
                "view_jobcard_invoice_authorization.soft_delete=0 AND view_jobcard_invoice_authorization.status = 'Requested' ORDER BY view_jobcard_invoice_authorization.job_date DESC",
              Workflow: null,
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Job card no.",
                  BindValue: "txt_jobcard_no",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Job card date",
                  BindValue: "txt_job_date",
                  Json_Attribute: "job_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice number(s)",
                  BindValue: "txt_invoice_numbers",
                  Json_Attribute: "invoice_numbers",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Invoice count",
                  BindValue: "txt_invoice_count",
                  Json_Attribute: "invoice_count",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Reg. no.",
                  BindValue: "txt_reg_no",
                  Json_Attribute: "reg_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer",
                  BindValue: "txt_customer_name",
                  Json_Attribute: "customer_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Requested by",
                  BindValue: "txt_requested_by_name",
                  Json_Attribute: "requested_by_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Request reason",
                  BindValue: "txt_request_reason",
                  Json_Attribute: "request_reason",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Authorization status",
                  BindValue: "txt_status",
                  Json_Attribute: "status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
